import React from "react";
import "./Orders.css";

export default function Orders() {
  return <div>Orders</div>;
}
